module.exports = __webpack_public_path__ + "img/cvv-info-en.4a8a3008.svg";